module.exports = __webpack_public_path__ + "img/team-02.c13da172.jpg";